import { gql } from '@apollo/client';
import { CORE_USER_FIELDS } from '../fragments';

const authUserFields = `
        email
        failedLoginAttempts
        avatar
        phoneNumber
        lastLoginAt
        questionnaireLastUpdatedAt
        passwordLastChangedAt
        passwordChangeRequired
        tagsIds
        roles
        batchName
        isDemo
        learningSubjects
        bookingCart{
          _id
        }
        points {
          currentDay
          currentWeek
          currentWeekTarget
          lifetime
        }
        meeoppAvatar {
          _id
        }
        profilePhoto {
          cloudinaryPublicId
          secureUrl
        }
        languagesSpoken
        instructorPreferences {
          preferredInstructors
          dislikedInstructors
        }
        organization {
          _id
          name
          code
          isDemo
          type
          availableTextTypes {
            textType
            count
          }
          settings {
            welcomeEmailLanguage
            visibleContentTypesBySubject {
              visibleContentTypes
              learningSubject
              isBundleVisible
            }
            visibleContentTypesForUser
            isBundleVisibleForUser
            contentTagAliases {
              contentTagId
              alias
            }
            libraryFilterAlwaysShowAllCurriculums
            isGoogleClassroomIntegrationEnabled
            isEasyLoginEnabled
            emailDomains
          }
        }
        isSuperAdmin
        isSchoolStaff
        schoolStaff {
          availableCurriculums {
            _id
            title
          }
          schoolClasses {
            _id
            title
            classCode
            isDemo
            curriculumLevel {
              contentTagId
              title
            }
            defaultThemeRootTagId
            archivedAt
            settings {
              contentTagAliases {
                contentTagId
                alias
              }
            }
          }
        }
`;

export const LOGIN = gql`
  ${CORE_USER_FIELDS}
  mutation Login($email: String!, $password: String!, $recaptchaVal: String) {
    login(email: $email, password: $password, recaptchaVal: $recaptchaVal) {
      user {
        ...CoreUserFields
        ${authUserFields}
      }
      accessToken
      refreshToken
      isMFAEnabled
      mfaUser {
        email
        _id
      }
    }
  }
`;

export const AUTHENTICATE = gql`
  ${CORE_USER_FIELDS}
  query Authenticate {
    authenticate {
      user {
        ...CoreUserFields
        ${authUserFields}
      }
      accessToken
    }
  }
`;

export const REFRESH_TOKEN = gql`
  mutation RefreshToken($refreshToken: String!) {
    refreshToken(refreshToken: $refreshToken) {
      accessToken
      refreshToken
    }
  }
`;

export const INVALIDATE_TOKENS = gql`
  mutation InvalidateTokens($refreshToken: String!, $accessToken: String) {
    invalidateTokens(refreshToken: $refreshToken, accessToken: $accessToken)
  }
`;

export const REDIRECT_TOKEN = gql`
  mutation RedirectToken($redirectToken: String!) {
    redirectToken(redirectToken: $redirectToken) {
      accessToken
      refreshToken
      isMFAEnabled
      mfaUser {
        _id
        email
      }
    }
  }
`;

export const MFA_EMAIL_TOKEN = gql`
  mutation MFAEmailToken($mfaEmailToken: String!) {
    mfaEmailToken(mfaEmailToken: $mfaEmailToken) {
      accessToken
      refreshToken
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  ${CORE_USER_FIELDS}
  mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
    self {
      changePassword(oldPassword: $oldPassword, newPassword: $newPassword) {
        ...CoreUserFields
        ${authUserFields}
      }
    }
  }
`;

export const REQUEST_PASSWORD_RESET = gql`
  mutation RequestPasswordReset($email: String!) {
    requestPasswordReset(email: $email)
  }
`;

export const REQUEST_USER_PASSWORD_RESET = gql`
  mutation RequestUserPasswordReset($userId: MongoObjectId!) {
    user(userId: $userId) {
      requestUserPasswordReset {
        _id
      }
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation ResetPassword($token: String!, $newPassword: String!) {
    resetPassword(token: $token, newPassword: $newPassword)
  }
`;

export const RESEND_MFA_EMAIL = gql`
  mutation ResendMFAEmail($userId: MongoObjectId!) {
    resendMFAEmail(userId: $userId)
  }
`;

export const SEND_AUTH_LINK = gql`
  mutation SendAuthLink($userId: MongoObjectId!, $path: String) {
    sendAuthLink(userId: $userId, path: $path)
  }
`;
